// source: witbooking/backoffice/common/common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.witbooking.backoffice.common.BundlePriceType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.BundleRestrictionType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.Colors', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.DayOfWeek', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.ExtraCategory', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.GrayScaleColors', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.IconPack', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.IssueSeverity', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.IssueTarget', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.Localizable', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.Multimedia', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.MultimediaTranslation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.Palette', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.PaletteType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.RoomDenominationType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.TravelWindow', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.TypographyClass', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.TypographyConfiguration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.ValidationIssue', null, global);
goog.exportSymbol('proto.witbooking.backoffice.common.ValidationIssueList', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.Multimedia = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.Multimedia, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.Multimedia.displayName = 'proto.witbooking.backoffice.common.Multimedia';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.MultimediaTranslation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.MultimediaTranslation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.MultimediaTranslation.displayName = 'proto.witbooking.backoffice.common.MultimediaTranslation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.Colors = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.Colors, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.Colors.displayName = 'proto.witbooking.backoffice.common.Colors';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.GrayScaleColors = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.GrayScaleColors, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.GrayScaleColors.displayName = 'proto.witbooking.backoffice.common.GrayScaleColors';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.Palette = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.Palette, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.Palette.displayName = 'proto.witbooking.backoffice.common.Palette';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.Localizable = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.Localizable, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.Localizable.displayName = 'proto.witbooking.backoffice.common.Localizable';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.TravelWindow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.common.TravelWindow.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.common.TravelWindow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.TravelWindow.displayName = 'proto.witbooking.backoffice.common.TravelWindow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.TypographyClass = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.TypographyClass, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.TypographyClass.displayName = 'proto.witbooking.backoffice.common.TypographyClass';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.TypographyConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.TypographyConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.TypographyConfiguration.displayName = 'proto.witbooking.backoffice.common.TypographyConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.IconPack = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.IconPack, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.IconPack.displayName = 'proto.witbooking.backoffice.common.IconPack';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.IssueTarget = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.IssueTarget, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.IssueTarget.displayName = 'proto.witbooking.backoffice.common.IssueTarget';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.ValidationIssue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.common.ValidationIssue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.ValidationIssue.displayName = 'proto.witbooking.backoffice.common.ValidationIssue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.common.ValidationIssueList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.common.ValidationIssueList.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.common.ValidationIssueList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.common.ValidationIssueList.displayName = 'proto.witbooking.backoffice.common.ValidationIssueList';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.Multimedia.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.Multimedia.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.Multimedia} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.Multimedia.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    url: jspb.Message.getFieldWithDefault(msg, 3, ""),
    order: (f = msg.getOrder()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.Multimedia}
 */
proto.witbooking.backoffice.common.Multimedia.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.Multimedia;
  return proto.witbooking.backoffice.common.Multimedia.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.Multimedia} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.Multimedia}
 */
proto.witbooking.backoffice.common.Multimedia.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.Multimedia.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.Multimedia.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.Multimedia} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.Multimedia.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.Multimedia.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Multimedia} returns this
 */
proto.witbooking.backoffice.common.Multimedia.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.Multimedia.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Multimedia} returns this
 */
proto.witbooking.backoffice.common.Multimedia.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.witbooking.backoffice.common.Multimedia.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Multimedia} returns this
 */
proto.witbooking.backoffice.common.Multimedia.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Int32Value order = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.witbooking.backoffice.common.Multimedia.prototype.getOrder = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.witbooking.backoffice.common.Multimedia} returns this
*/
proto.witbooking.backoffice.common.Multimedia.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.Multimedia} returns this
 */
proto.witbooking.backoffice.common.Multimedia.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.Multimedia.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.MultimediaTranslation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.MultimediaTranslation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.MultimediaTranslation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.MultimediaTranslation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.MultimediaTranslation}
 */
proto.witbooking.backoffice.common.MultimediaTranslation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.MultimediaTranslation;
  return proto.witbooking.backoffice.common.MultimediaTranslation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.MultimediaTranslation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.MultimediaTranslation}
 */
proto.witbooking.backoffice.common.MultimediaTranslation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.MultimediaTranslation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.MultimediaTranslation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.MultimediaTranslation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.MultimediaTranslation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.MultimediaTranslation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.MultimediaTranslation} returns this
 */
proto.witbooking.backoffice.common.MultimediaTranslation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.MultimediaTranslation.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.MultimediaTranslation} returns this
 */
proto.witbooking.backoffice.common.MultimediaTranslation.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.common.MultimediaTranslation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.MultimediaTranslation} returns this
 */
proto.witbooking.backoffice.common.MultimediaTranslation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.Colors.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.Colors.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.Colors} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.Colors.toObject = function(includeInstance, msg) {
  var f, obj = {
    light: jspb.Message.getFieldWithDefault(msg, 1, ""),
    main: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dark: jspb.Message.getFieldWithDefault(msg, 3, ""),
    contrasttext: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.common.Colors.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.Colors;
  return proto.witbooking.backoffice.common.Colors.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.Colors} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.common.Colors.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLight(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMain(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDark(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContrasttext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.Colors.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.Colors.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.Colors} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.Colors.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLight();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMain();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDark();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContrasttext();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string light = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.Colors.prototype.getLight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Colors} returns this
 */
proto.witbooking.backoffice.common.Colors.prototype.setLight = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string main = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.Colors.prototype.getMain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Colors} returns this
 */
proto.witbooking.backoffice.common.Colors.prototype.setMain = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string dark = 3;
 * @return {string}
 */
proto.witbooking.backoffice.common.Colors.prototype.getDark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Colors} returns this
 */
proto.witbooking.backoffice.common.Colors.prototype.setDark = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string contrastText = 4;
 * @return {string}
 */
proto.witbooking.backoffice.common.Colors.prototype.getContrasttext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Colors} returns this
 */
proto.witbooking.backoffice.common.Colors.prototype.setContrasttext = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.GrayScaleColors.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.GrayScaleColors} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.GrayScaleColors.toObject = function(includeInstance, msg) {
  var f, obj = {
    gray25: jspb.Message.getFieldWithDefault(msg, 1, ""),
    gray50: jspb.Message.getFieldWithDefault(msg, 2, ""),
    gray100: jspb.Message.getFieldWithDefault(msg, 3, ""),
    gray200: jspb.Message.getFieldWithDefault(msg, 4, ""),
    gray300: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.GrayScaleColors}
 */
proto.witbooking.backoffice.common.GrayScaleColors.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.GrayScaleColors;
  return proto.witbooking.backoffice.common.GrayScaleColors.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.GrayScaleColors} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.GrayScaleColors}
 */
proto.witbooking.backoffice.common.GrayScaleColors.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGray25(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGray50(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGray100(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGray200(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setGray300(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.GrayScaleColors.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.GrayScaleColors} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.GrayScaleColors.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGray25();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGray50();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGray100();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGray200();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGray300();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string gray_25 = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.getGray25 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.GrayScaleColors} returns this
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.setGray25 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string gray_50 = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.getGray50 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.GrayScaleColors} returns this
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.setGray50 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string gray_100 = 3;
 * @return {string}
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.getGray100 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.GrayScaleColors} returns this
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.setGray100 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string gray_200 = 4;
 * @return {string}
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.getGray200 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.GrayScaleColors} returns this
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.setGray200 = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string gray_300 = 5;
 * @return {string}
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.getGray300 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.GrayScaleColors} returns this
 */
proto.witbooking.backoffice.common.GrayScaleColors.prototype.setGray300 = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.Palette.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.Palette.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.Palette} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.Palette.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    primary: (f = msg.getPrimary()) && proto.witbooking.backoffice.common.Colors.toObject(includeInstance, f),
    secondary: (f = msg.getSecondary()) && proto.witbooking.backoffice.common.Colors.toObject(includeInstance, f),
    error: (f = msg.getError()) && proto.witbooking.backoffice.common.Colors.toObject(includeInstance, f),
    success: (f = msg.getSuccess()) && proto.witbooking.backoffice.common.Colors.toObject(includeInstance, f),
    black: (f = msg.getBlack()) && proto.witbooking.backoffice.common.Colors.toObject(includeInstance, f),
    white: (f = msg.getWhite()) && proto.witbooking.backoffice.common.Colors.toObject(includeInstance, f),
    gray: (f = msg.getGray()) && proto.witbooking.backoffice.common.GrayScaleColors.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.Palette}
 */
proto.witbooking.backoffice.common.Palette.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.Palette;
  return proto.witbooking.backoffice.common.Palette.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.Palette} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.Palette}
 */
proto.witbooking.backoffice.common.Palette.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {!proto.witbooking.backoffice.common.PaletteType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.common.Colors;
      reader.readMessage(value,proto.witbooking.backoffice.common.Colors.deserializeBinaryFromReader);
      msg.setPrimary(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.common.Colors;
      reader.readMessage(value,proto.witbooking.backoffice.common.Colors.deserializeBinaryFromReader);
      msg.setSecondary(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.common.Colors;
      reader.readMessage(value,proto.witbooking.backoffice.common.Colors.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.common.Colors;
      reader.readMessage(value,proto.witbooking.backoffice.common.Colors.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.common.Colors;
      reader.readMessage(value,proto.witbooking.backoffice.common.Colors.deserializeBinaryFromReader);
      msg.setBlack(value);
      break;
    case 9:
      var value = new proto.witbooking.backoffice.common.Colors;
      reader.readMessage(value,proto.witbooking.backoffice.common.Colors.deserializeBinaryFromReader);
      msg.setWhite(value);
      break;
    case 10:
      var value = new proto.witbooking.backoffice.common.GrayScaleColors;
      reader.readMessage(value,proto.witbooking.backoffice.common.GrayScaleColors.deserializeBinaryFromReader);
      msg.setGray(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.Palette.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.Palette.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.Palette} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.Palette.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPrimary();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.common.Colors.serializeBinaryToWriter
    );
  }
  f = message.getSecondary();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.common.Colors.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.witbooking.backoffice.common.Colors.serializeBinaryToWriter
    );
  }
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.backoffice.common.Colors.serializeBinaryToWriter
    );
  }
  f = message.getBlack();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.backoffice.common.Colors.serializeBinaryToWriter
    );
  }
  f = message.getWhite();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.witbooking.backoffice.common.Colors.serializeBinaryToWriter
    );
  }
  f = message.getGray();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.witbooking.backoffice.common.GrayScaleColors.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.Palette.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
 */
proto.witbooking.backoffice.common.Palette.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.Palette.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
 */
proto.witbooking.backoffice.common.Palette.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional PaletteType type = 3;
 * @return {!proto.witbooking.backoffice.common.PaletteType}
 */
proto.witbooking.backoffice.common.Palette.prototype.getType = function() {
  return /** @type {!proto.witbooking.backoffice.common.PaletteType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.witbooking.backoffice.common.PaletteType} value
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
 */
proto.witbooking.backoffice.common.Palette.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Colors primary = 4;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.common.Palette.prototype.getPrimary = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.Colors, 4));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
*/
proto.witbooking.backoffice.common.Palette.prototype.setPrimary = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
 */
proto.witbooking.backoffice.common.Palette.prototype.clearPrimary = function() {
  return this.setPrimary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.Palette.prototype.hasPrimary = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Colors secondary = 5;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.common.Palette.prototype.getSecondary = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.Colors, 5));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
*/
proto.witbooking.backoffice.common.Palette.prototype.setSecondary = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
 */
proto.witbooking.backoffice.common.Palette.prototype.clearSecondary = function() {
  return this.setSecondary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.Palette.prototype.hasSecondary = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Colors error = 6;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.common.Palette.prototype.getError = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.Colors, 6));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
*/
proto.witbooking.backoffice.common.Palette.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
 */
proto.witbooking.backoffice.common.Palette.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.Palette.prototype.hasError = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Colors success = 7;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.common.Palette.prototype.getSuccess = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.Colors, 7));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
*/
proto.witbooking.backoffice.common.Palette.prototype.setSuccess = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
 */
proto.witbooking.backoffice.common.Palette.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.Palette.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Colors black = 8;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.common.Palette.prototype.getBlack = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.Colors, 8));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
*/
proto.witbooking.backoffice.common.Palette.prototype.setBlack = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
 */
proto.witbooking.backoffice.common.Palette.prototype.clearBlack = function() {
  return this.setBlack(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.Palette.prototype.hasBlack = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Colors white = 9;
 * @return {?proto.witbooking.backoffice.common.Colors}
 */
proto.witbooking.backoffice.common.Palette.prototype.getWhite = function() {
  return /** @type{?proto.witbooking.backoffice.common.Colors} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.Colors, 9));
};


/**
 * @param {?proto.witbooking.backoffice.common.Colors|undefined} value
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
*/
proto.witbooking.backoffice.common.Palette.prototype.setWhite = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
 */
proto.witbooking.backoffice.common.Palette.prototype.clearWhite = function() {
  return this.setWhite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.Palette.prototype.hasWhite = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional GrayScaleColors gray = 10;
 * @return {?proto.witbooking.backoffice.common.GrayScaleColors}
 */
proto.witbooking.backoffice.common.Palette.prototype.getGray = function() {
  return /** @type{?proto.witbooking.backoffice.common.GrayScaleColors} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.GrayScaleColors, 10));
};


/**
 * @param {?proto.witbooking.backoffice.common.GrayScaleColors|undefined} value
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
*/
proto.witbooking.backoffice.common.Palette.prototype.setGray = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.Palette} returns this
 */
proto.witbooking.backoffice.common.Palette.prototype.clearGray = function() {
  return this.setGray(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.Palette.prototype.hasGray = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.Localizable.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.Localizable.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.Localizable} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.Localizable.toObject = function(includeInstance, msg) {
  var f, obj = {
    country: jspb.Message.getFieldWithDefault(msg, 1, ""),
    city: jspb.Message.getFieldWithDefault(msg, 2, ""),
    address: jspb.Message.getFieldWithDefault(msg, 3, ""),
    zipCode: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.Localizable}
 */
proto.witbooking.backoffice.common.Localizable.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.Localizable;
  return proto.witbooking.backoffice.common.Localizable.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.Localizable} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.Localizable}
 */
proto.witbooking.backoffice.common.Localizable.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.Localizable.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.Localizable.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.Localizable} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.Localizable.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string country = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.Localizable.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Localizable} returns this
 */
proto.witbooking.backoffice.common.Localizable.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string city = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.Localizable.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Localizable} returns this
 */
proto.witbooking.backoffice.common.Localizable.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address = 3;
 * @return {string}
 */
proto.witbooking.backoffice.common.Localizable.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Localizable} returns this
 */
proto.witbooking.backoffice.common.Localizable.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string zip_code = 4;
 * @return {string}
 */
proto.witbooking.backoffice.common.Localizable.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.Localizable} returns this
 */
proto.witbooking.backoffice.common.Localizable.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.common.TravelWindow.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.TravelWindow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.TravelWindow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.TravelWindow.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    weekDaysList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.TravelWindow}
 */
proto.witbooking.backoffice.common.TravelWindow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.TravelWindow;
  return proto.witbooking.backoffice.common.TravelWindow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.TravelWindow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.TravelWindow}
 */
proto.witbooking.backoffice.common.TravelWindow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 3:
      var value = /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (reader.readPackedEnum());
      msg.setWeekDaysList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.TravelWindow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.TravelWindow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.TravelWindow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getWeekDaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.common.TravelWindow} returns this
*/
proto.witbooking.backoffice.common.TravelWindow.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TravelWindow} returns this
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.common.TravelWindow} returns this
*/
proto.witbooking.backoffice.common.TravelWindow.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TravelWindow} returns this
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated DayOfWeek week_days = 3;
 * @return {!Array<!proto.witbooking.backoffice.common.DayOfWeek>}
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.getWeekDaysList = function() {
  return /** @type {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.DayOfWeek>} value
 * @return {!proto.witbooking.backoffice.common.TravelWindow} returns this
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.setWeekDaysList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.witbooking.backoffice.common.DayOfWeek} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.common.TravelWindow} returns this
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.addWeekDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.common.TravelWindow} returns this
 */
proto.witbooking.backoffice.common.TravelWindow.prototype.clearWeekDaysList = function() {
  return this.setWeekDaysList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.TypographyClass.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.TypographyClass} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.TypographyClass.toObject = function(includeInstance, msg) {
  var f, obj = {
    fontsize: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fontweight: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fontfamily: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lineheight: jspb.Message.getFieldWithDefault(msg, 4, ""),
    fontstyle: jspb.Message.getFieldWithDefault(msg, 5, ""),
    letterspacing: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyClass.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.TypographyClass;
  return proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.TypographyClass} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontsize(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontweight(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontfamily(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLineheight(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontstyle(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLetterspacing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.TypographyClass} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFontsize();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFontweight();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFontfamily();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLineheight();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFontstyle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLetterspacing();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string fontSize = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.getFontsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyClass} returns this
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.setFontsize = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string fontWeight = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.getFontweight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyClass} returns this
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.setFontweight = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string fontFamily = 3;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.getFontfamily = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyClass} returns this
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.setFontfamily = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string lineHeight = 4;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.getLineheight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyClass} returns this
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.setLineheight = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string fontStyle = 5;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.getFontstyle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyClass} returns this
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.setFontstyle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string letterSpacing = 6;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.getLetterspacing = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyClass} returns this
 */
proto.witbooking.backoffice.common.TypographyClass.prototype.setLetterspacing = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.TypographyConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.TypographyConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.TypographyConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    fontsize: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fontweightlight: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fontweightregular: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fontweightmedium: jspb.Message.getFieldWithDefault(msg, 4, ""),
    fontweightbold: jspb.Message.getFieldWithDefault(msg, 5, ""),
    htmlfontsize: jspb.Message.getFieldWithDefault(msg, 6, ""),
    fontfamily: jspb.Message.getFieldWithDefault(msg, 7, ""),
    h1: (f = msg.getH1()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    h2: (f = msg.getH2()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    h3: (f = msg.getH3()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    h4: (f = msg.getH4()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    h5: (f = msg.getH5()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    h6: (f = msg.getH6()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    subtitle1: (f = msg.getSubtitle1()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    subtitle2: (f = msg.getSubtitle2()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    subtitle3: (f = msg.getSubtitle3()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    body1: (f = msg.getBody1()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    body2: (f = msg.getBody2()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    body3: (f = msg.getBody3()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    button: (f = msg.getButton()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    caption: (f = msg.getCaption()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f),
    overline: (f = msg.getOverline()) && proto.witbooking.backoffice.common.TypographyClass.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.TypographyConfiguration;
  return proto.witbooking.backoffice.common.TypographyConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.TypographyConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontsize(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontweightlight(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontweightregular(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontweightmedium(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontweightbold(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtmlfontsize(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontfamily(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setH1(value);
      break;
    case 9:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setH2(value);
      break;
    case 10:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setH3(value);
      break;
    case 11:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setH4(value);
      break;
    case 12:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setH5(value);
      break;
    case 13:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setH6(value);
      break;
    case 14:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setSubtitle1(value);
      break;
    case 15:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setSubtitle2(value);
      break;
    case 16:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setSubtitle3(value);
      break;
    case 17:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setBody1(value);
      break;
    case 18:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setBody2(value);
      break;
    case 19:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setBody3(value);
      break;
    case 20:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setButton(value);
      break;
    case 21:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setCaption(value);
      break;
    case 22:
      var value = new proto.witbooking.backoffice.common.TypographyClass;
      reader.readMessage(value,proto.witbooking.backoffice.common.TypographyClass.deserializeBinaryFromReader);
      msg.setOverline(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.TypographyConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.TypographyConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.TypographyConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFontsize();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFontweightlight();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFontweightregular();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFontweightmedium();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFontweightbold();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHtmlfontsize();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFontfamily();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getH1();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getH2();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getH3();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getH4();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getH5();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getH6();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getSubtitle1();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getSubtitle2();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getSubtitle3();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getBody1();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getBody2();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getBody3();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getButton();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getCaption();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
  f = message.getOverline();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.witbooking.backoffice.common.TypographyClass.serializeBinaryToWriter
    );
  }
};


/**
 * optional string fontSize = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getFontsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setFontsize = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string fontWeightLight = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getFontweightlight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setFontweightlight = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string fontWeightRegular = 3;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getFontweightregular = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setFontweightregular = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string fontWeightMedium = 4;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getFontweightmedium = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setFontweightmedium = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string fontWeightBold = 5;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getFontweightbold = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setFontweightbold = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string htmlFontSize = 6;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getHtmlfontsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setHtmlfontsize = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string fontFamily = 7;
 * @return {string}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getFontfamily = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setFontfamily = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional TypographyClass h1 = 8;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getH1 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 8));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setH1 = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearH1 = function() {
  return this.setH1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasH1 = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional TypographyClass h2 = 9;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getH2 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 9));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setH2 = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearH2 = function() {
  return this.setH2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasH2 = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional TypographyClass h3 = 10;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getH3 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 10));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setH3 = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearH3 = function() {
  return this.setH3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasH3 = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional TypographyClass h4 = 11;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getH4 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 11));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setH4 = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearH4 = function() {
  return this.setH4(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasH4 = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional TypographyClass h5 = 12;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getH5 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 12));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setH5 = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearH5 = function() {
  return this.setH5(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasH5 = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TypographyClass h6 = 13;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getH6 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 13));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setH6 = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearH6 = function() {
  return this.setH6(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasH6 = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional TypographyClass subtitle1 = 14;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getSubtitle1 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 14));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setSubtitle1 = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearSubtitle1 = function() {
  return this.setSubtitle1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasSubtitle1 = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional TypographyClass subtitle2 = 15;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getSubtitle2 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 15));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setSubtitle2 = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearSubtitle2 = function() {
  return this.setSubtitle2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasSubtitle2 = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional TypographyClass subtitle3 = 16;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getSubtitle3 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 16));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setSubtitle3 = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearSubtitle3 = function() {
  return this.setSubtitle3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasSubtitle3 = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional TypographyClass body1 = 17;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getBody1 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 17));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setBody1 = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearBody1 = function() {
  return this.setBody1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasBody1 = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional TypographyClass body2 = 18;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getBody2 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 18));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setBody2 = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearBody2 = function() {
  return this.setBody2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasBody2 = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional TypographyClass body3 = 19;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getBody3 = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 19));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setBody3 = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearBody3 = function() {
  return this.setBody3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasBody3 = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional TypographyClass button = 20;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getButton = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 20));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setButton = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearButton = function() {
  return this.setButton(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasButton = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional TypographyClass caption = 21;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getCaption = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 21));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setCaption = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearCaption = function() {
  return this.setCaption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasCaption = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional TypographyClass overline = 22;
 * @return {?proto.witbooking.backoffice.common.TypographyClass}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.getOverline = function() {
  return /** @type{?proto.witbooking.backoffice.common.TypographyClass} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.TypographyClass, 22));
};


/**
 * @param {?proto.witbooking.backoffice.common.TypographyClass|undefined} value
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
*/
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.setOverline = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.TypographyConfiguration} returns this
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.clearOverline = function() {
  return this.setOverline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.TypographyConfiguration.prototype.hasOverline = function() {
  return jspb.Message.getField(this, 22) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.IconPack.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.IconPack.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.IconPack} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.IconPack.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.IconPack}
 */
proto.witbooking.backoffice.common.IconPack.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.IconPack;
  return proto.witbooking.backoffice.common.IconPack.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.IconPack} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.IconPack}
 */
proto.witbooking.backoffice.common.IconPack.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.IconPack.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.IconPack.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.IconPack} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.IconPack.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.IconPack.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.IconPack} returns this
 */
proto.witbooking.backoffice.common.IconPack.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.IconPack.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.IconPack} returns this
 */
proto.witbooking.backoffice.common.IconPack.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.IssueTarget.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.IssueTarget} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.IssueTarget.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accommodationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    category: jspb.Message.getFieldWithDefault(msg, 3, 0),
    extraTicker: jspb.Message.getFieldWithDefault(msg, 4, ""),
    field: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.IssueTarget}
 */
proto.witbooking.backoffice.common.IssueTarget.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.IssueTarget;
  return proto.witbooking.backoffice.common.IssueTarget.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.IssueTarget} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.IssueTarget}
 */
proto.witbooking.backoffice.common.IssueTarget.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPropertyTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccommodationId(value);
      break;
    case 3:
      var value = /** @type {!proto.witbooking.backoffice.common.ExtraCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtraTicker(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.IssueTarget.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.IssueTarget} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.IssueTarget.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccommodationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getExtraTicker();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getField();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string property_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.getPropertyTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.IssueTarget} returns this
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.setPropertyTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string accommodation_id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.getAccommodationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.IssueTarget} returns this
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.setAccommodationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ExtraCategory category = 3;
 * @return {!proto.witbooking.backoffice.common.ExtraCategory}
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.getCategory = function() {
  return /** @type {!proto.witbooking.backoffice.common.ExtraCategory} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.witbooking.backoffice.common.ExtraCategory} value
 * @return {!proto.witbooking.backoffice.common.IssueTarget} returns this
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string extra_ticker = 4;
 * @return {string}
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.getExtraTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.IssueTarget} returns this
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.setExtraTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string field = 5;
 * @return {string}
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.IssueTarget} returns this
 */
proto.witbooking.backoffice.common.IssueTarget.prototype.setField = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.ValidationIssue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.ValidationIssue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.ValidationIssue.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    messageKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    severity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    target: (f = msg.getTarget()) && proto.witbooking.backoffice.common.IssueTarget.toObject(includeInstance, f),
    paramsMap: (f = msg.getParamsMap()) ? f.toObject(includeInstance, undefined) : [],
    defaultMessage: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.ValidationIssue}
 */
proto.witbooking.backoffice.common.ValidationIssue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.ValidationIssue;
  return proto.witbooking.backoffice.common.ValidationIssue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.ValidationIssue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.ValidationIssue}
 */
proto.witbooking.backoffice.common.ValidationIssue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageKey(value);
      break;
    case 3:
      var value = /** @type {!proto.witbooking.backoffice.common.IssueSeverity} */ (reader.readEnum());
      msg.setSeverity(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.common.IssueTarget;
      reader.readMessage(value,proto.witbooking.backoffice.common.IssueTarget.deserializeBinaryFromReader);
      msg.setTarget(value);
      break;
    case 5:
      var value = msg.getParamsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.ValidationIssue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.ValidationIssue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.ValidationIssue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessageKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSeverity();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTarget();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.common.IssueTarget.serializeBinaryToWriter
    );
  }
  f = message.getParamsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getDefaultMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.ValidationIssue} returns this
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message_key = 2;
 * @return {string}
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.getMessageKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.ValidationIssue} returns this
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.setMessageKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional IssueSeverity severity = 3;
 * @return {!proto.witbooking.backoffice.common.IssueSeverity}
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.getSeverity = function() {
  return /** @type {!proto.witbooking.backoffice.common.IssueSeverity} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.witbooking.backoffice.common.IssueSeverity} value
 * @return {!proto.witbooking.backoffice.common.ValidationIssue} returns this
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.setSeverity = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional IssueTarget target = 4;
 * @return {?proto.witbooking.backoffice.common.IssueTarget}
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.getTarget = function() {
  return /** @type{?proto.witbooking.backoffice.common.IssueTarget} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.common.IssueTarget, 4));
};


/**
 * @param {?proto.witbooking.backoffice.common.IssueTarget|undefined} value
 * @return {!proto.witbooking.backoffice.common.ValidationIssue} returns this
*/
proto.witbooking.backoffice.common.ValidationIssue.prototype.setTarget = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.common.ValidationIssue} returns this
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.clearTarget = function() {
  return this.setTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.hasTarget = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * map<string, string> params = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.getParamsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.common.ValidationIssue} returns this
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.clearParamsMap = function() {
  this.getParamsMap().clear();
  return this;};


/**
 * optional string default_message = 6;
 * @return {string}
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.getDefaultMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.common.ValidationIssue} returns this
 */
proto.witbooking.backoffice.common.ValidationIssue.prototype.setDefaultMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.common.ValidationIssueList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.common.ValidationIssueList.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.common.ValidationIssueList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.common.ValidationIssueList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.ValidationIssueList.toObject = function(includeInstance, msg) {
  var f, obj = {
    issuesList: jspb.Message.toObjectList(msg.getIssuesList(),
    proto.witbooking.backoffice.common.ValidationIssue.toObject, includeInstance),
    omitted: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.common.ValidationIssueList}
 */
proto.witbooking.backoffice.common.ValidationIssueList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.common.ValidationIssueList;
  return proto.witbooking.backoffice.common.ValidationIssueList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.common.ValidationIssueList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.common.ValidationIssueList}
 */
proto.witbooking.backoffice.common.ValidationIssueList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.common.ValidationIssue;
      reader.readMessage(value,proto.witbooking.backoffice.common.ValidationIssue.deserializeBinaryFromReader);
      msg.addIssues(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOmitted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.common.ValidationIssueList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.common.ValidationIssueList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.common.ValidationIssueList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.common.ValidationIssueList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.common.ValidationIssue.serializeBinaryToWriter
    );
  }
  f = message.getOmitted();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated ValidationIssue issues = 1;
 * @return {!Array<!proto.witbooking.backoffice.common.ValidationIssue>}
 */
proto.witbooking.backoffice.common.ValidationIssueList.prototype.getIssuesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.common.ValidationIssue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.common.ValidationIssue, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.ValidationIssue>} value
 * @return {!proto.witbooking.backoffice.common.ValidationIssueList} returns this
*/
proto.witbooking.backoffice.common.ValidationIssueList.prototype.setIssuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.common.ValidationIssue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.common.ValidationIssue}
 */
proto.witbooking.backoffice.common.ValidationIssueList.prototype.addIssues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.common.ValidationIssue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.common.ValidationIssueList} returns this
 */
proto.witbooking.backoffice.common.ValidationIssueList.prototype.clearIssuesList = function() {
  return this.setIssuesList([]);
};


/**
 * optional int32 omitted = 2;
 * @return {number}
 */
proto.witbooking.backoffice.common.ValidationIssueList.prototype.getOmitted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.common.ValidationIssueList} returns this
 */
proto.witbooking.backoffice.common.ValidationIssueList.prototype.setOmitted = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.common.PaletteType = {
  INVALID: 0,
  PUBLIC: 1,
  PRIVATE: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.common.RoomDenominationType = {
  ROOM_DENOMINATION_TYPE_INVALID: 0,
  ROOM_DENOMINATION_TYPE_UNIT: 1,
  ROOM_DENOMINATION_TYPE_ROOMS: 2,
  ROOM_DENOMINATION_TYPE_APARTMENTS: 3,
  ROOM_DENOMINATION_TYPE_BUNGALOWS: 4,
  ROOM_DENOMINATION_TYPE_CABINS: 5,
  ROOM_DENOMINATION_TYPE_HOUSES: 6,
  ROOM_DENOMINATION_TYPE_SHIP_CABIN: 7,
  ROOM_DENOMINATION_TYPE_VILLAS: 8,
  ROOM_DENOMINATION_TYPE_BEDS: 9,
  ROOM_DENOMINATION_TYPE_PITCHES: 10,
  ROOM_DENOMINATION_TYPE_HOLIDAY_VILLAGES: 11,
  ROOM_DENOMINATION_TYPE_MOBILE_HOME: 12,
  ROOM_DENOMINATION_TYPE_GLAMPING: 13,
  ROOM_DENOMINATION_TYPE_CARAVANS: 14
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.common.DayOfWeek = {
  MONDAY: 0,
  TUESDAY: 1,
  WEDNESDAY: 2,
  THURSDAY: 3,
  FRIDAY: 4,
  SATURDAY: 5,
  SUNDAY: 6
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.common.BundlePriceType = {
  BUNDLE_TYPE_FIXED: 0,
  BUNDLE_TYPE_DYNAMIC: 1,
  BUNDLE_TYPE_OWN: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.common.BundleRestrictionType = {
  OWN_RESTRICTION_TYPE: 0,
  SHARED_RESTRICTION_TYPE: 1
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.common.ExtraCategory = {
  EXTRA_CATEGORY_NONE: 0,
  EXTRA_CATEGORY_VEHICLE: 1,
  EXTRA_CATEGORY_FACILITIES: 2
};

/**
 * @enum {number}
 */
proto.witbooking.backoffice.common.IssueSeverity = {
  ISSUE_SEVERITY_UNSPECIFIED: 0,
  ISSUE_SEVERITY_BLOCKING: 1,
  ISSUE_SEVERITY_WARNING: 2
};

goog.object.extend(exports, proto.witbooking.backoffice.common);
